const STORAGE_KEY = 'isms_admin_theme';

const state = {
  isDark: localStorage.getItem(STORAGE_KEY) === 'dark',
  primaryColor: "#F26522",
  buttonColor: "#1B2340",
};

const mutations = {
  toggleTheme(state) {
    state.isDark = !state.isDark;
    const val = state.isDark ? 'dark' : 'light';
    localStorage.setItem(STORAGE_KEY, val);
    if (state.isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  },
  setTheme(state, isDark) {
    state.isDark = isDark;
    const val = isDark ? 'dark' : 'light';
    localStorage.setItem(STORAGE_KEY, val);
    if (isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  },
  setPrimaryColor(state, data) {
    state.primaryColor = data.primaryColor;
  },
  setButtonColor(state, data) {
    state.buttonColor = data.buttonColor;
  }
};

const actions = {
  initTheme({ state, commit }) {
    commit('setTheme', state.isDark);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};